<template>
  <v-btn
    v-for="tab in tabs"
    :key="tab.name"
    :to="tab.route"
    variant="text"
    class="mx-2 text-capitalize d-none d-md-flex"
    color="black"
  >
    {{ tab.name }}
  </v-btn>

  <AppBarIconTabs />
</template>

<script setup lang="ts">
  import { portal, resolveNavLabel, FEATURE_CATALOG } from '@/config/portal'
  import type { FeatureKey } from '@/config/portal'

  import AppBarIconTabs from './AppBarIconTabs.vue'

  // Curated desktop top-bar subset (historically narrower than the drawer:
  // no Home, no Training). Filtered to the active portal's enabled features
  // so a portal never shows tabs its config excludes.
  const TOP_BAR_FEATURES: FeatureKey[] = [
    'documents',
    'software',
    'hardware',
    'knowledge_base',
    'link_budget',
  ]

  const tabs = computed(() =>
    TOP_BAR_FEATURES.filter((feature) => portal.features.includes(feature)).map((feature) => ({
      name: resolveNavLabel(feature, portal),
      route: { name: FEATURE_CATALOG[feature].routeName },
    })),
  )

  defineExpose({ tabs })
</script>
